import { render, staticRenderFns } from "./KiemeltKategoria.vue?vue&type=template&id=3c614ca6&"
import script from "./KiemeltKategoria.vue?vue&type=script&lang=js&"
export * from "./KiemeltKategoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports